import { c as _c } from "react/compiler-runtime";
import { Box, Stack, Typography } from '@mui/material';
import { MultiSelectInput } from '@/components/form/baseInputs/MultiSelectInput';
import { SelectInput } from '@/components/form/baseInputs/SelectInput';
import { TextInput } from '@/components/form/baseInputs/TextInput';
import { COLORS } from '@/styles/tokens/colors';
import { UnreachableError } from '@/utils/errors';
import type { AnswerReviewEditEvent, AnswerReviewFieldViewModel, AnswerReviewValue, AnswerReviewWorkbenchProps } from './AnswerReviewWorkbench.types';
interface AnswerReviewEditorProps extends Pick<AnswerReviewWorkbenchProps, 'onAnswerChange' | 'onAnswerBlur'> {
  field: AnswerReviewFieldViewModel;
  readOnly: boolean;
  autoFocus?: boolean;
  /** Reports when a select opens or closes its portaled menu. */
  onMenuOpenChange?: (isOpen: boolean) => void;
}
export function AnswerReviewEditor(t0) {
  const $ = _c(125);
  const {
    field,
    readOnly,
    autoFocus,
    onMenuOpenChange,
    onAnswerChange,
    onAnswerBlur
  } = t0;
  let t1;
  if ($[0] !== field.id || $[1] !== onAnswerChange) {
    t1 = (value, save) => {
      onAnswerChange?.({
        fieldId: field.id,
        value,
        save
      });
    };
    $[0] = field.id;
    $[1] = onAnswerChange;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleChange = t1;
  switch (field.editor.kind) {
    case "conclusion":
      {
        return null;
      }
    case "decimal":
      {
        const t2 = `answer-${field.id}`;
        const t3 = typeof field.currentRevision?.value === "string" ? field.currentRevision.value : "";
        let t4;
        if ($[3] !== field.label) {
          t4 = {
            "aria-label": field.label,
            inputMode: "decimal"
          };
          $[3] = field.label;
          $[4] = t4;
        } else {
          t4 = $[4];
        }
        let t5;
        if ($[5] !== handleChange) {
          t5 = event_4 => handleChange(event_4.target.value || null, "debounced");
          $[5] = handleChange;
          $[6] = t5;
        } else {
          t5 = $[6];
        }
        let t6;
        if ($[7] !== field.id || $[8] !== onAnswerBlur) {
          t6 = () => onAnswerBlur?.(field.id);
          $[7] = field.id;
          $[8] = onAnswerBlur;
          $[9] = t6;
        } else {
          t6 = $[9];
        }
        let t7;
        if ($[10] !== autoFocus || $[11] !== field.label || $[12] !== field.validationMessage || $[13] !== readOnly || $[14] !== t2 || $[15] !== t3 || $[16] !== t4 || $[17] !== t5 || $[18] !== t6) {
          t7 = <TextInput id={t2} autoFocus={autoFocus} label={field.label} hideLabel={true} disabled={readOnly} value={t3} inputProps={t4} errorMessage={field.validationMessage} onChange={t5} onBlur={t6} />;
          $[10] = autoFocus;
          $[11] = field.label;
          $[12] = field.validationMessage;
          $[13] = readOnly;
          $[14] = t2;
          $[15] = t3;
          $[16] = t4;
          $[17] = t5;
          $[18] = t6;
          $[19] = t7;
        } else {
          t7 = $[19];
        }
        return t7;
      }
    case "text":
      {
        const t2 = `answer-${field.id}`;
        const t3 = `answer-review-label-${field.id}`;
        const t4 = typeof field.currentRevision?.value === "string" ? field.currentRevision.value : "";
        const t5 = field.editor.multiline ? 1 : undefined;
        const t6 = field.currentRevision?.confidence === "NOT_FOUND" ? "Nothing found" : field.editor.placeholder;
        let t7;
        if ($[20] !== field.editor.maxLength || $[21] !== field.label) {
          t7 = {
            "aria-label": field.label,
            maxLength: field.editor.maxLength
          };
          $[20] = field.editor.maxLength;
          $[21] = field.label;
          $[22] = t7;
        } else {
          t7 = $[22];
        }
        let t8;
        if ($[23] !== handleChange) {
          t8 = event_3 => handleChange(event_3.target.value, "debounced");
          $[23] = handleChange;
          $[24] = t8;
        } else {
          t8 = $[24];
        }
        let t9;
        if ($[25] !== field.id || $[26] !== onAnswerBlur) {
          t9 = () => onAnswerBlur?.(field.id);
          $[25] = field.id;
          $[26] = onAnswerBlur;
          $[27] = t9;
        } else {
          t9 = $[27];
        }
        let t10;
        if ($[28] !== autoFocus || $[29] !== field.editor.multiline || $[30] !== field.label || $[31] !== field.validationMessage || $[32] !== readOnly || $[33] !== t2 || $[34] !== t3 || $[35] !== t4 || $[36] !== t5 || $[37] !== t6 || $[38] !== t7 || $[39] !== t8 || $[40] !== t9) {
          t10 = <Stack gap={0.5}><TextInput id={t2} autoFocus={autoFocus} label={field.label} hideLabel={true} disabled={readOnly} aria-labelledby={t3} value={t4} multiline={field.editor.multiline} minRows={t5} placeholder={t6} errorMessage={field.validationMessage} inputProps={t7} onChange={t8} onBlur={t9} /></Stack>;
          $[28] = autoFocus;
          $[29] = field.editor.multiline;
          $[30] = field.label;
          $[31] = field.validationMessage;
          $[32] = readOnly;
          $[33] = t2;
          $[34] = t3;
          $[35] = t4;
          $[36] = t5;
          $[37] = t6;
          $[38] = t7;
          $[39] = t8;
          $[40] = t9;
          $[41] = t10;
        } else {
          t10 = $[41];
        }
        return t10;
      }
    case "singleSelect":
      {
        const t2 = `answer-${field.id}`;
        const t3 = field.label;
        const t4 = `answer-review-label-${field.id}`;
        const t5 = typeof field.currentRevision?.value === "string" ? field.currentRevision.value : "";
        let t6;
        if ($[42] !== field.editor.options) {
          t6 = field.editor.options.map(_temp);
          $[42] = field.editor.options;
          $[43] = t6;
        } else {
          t6 = $[43];
        }
        const t7 = field.currentRevision?.confidence === "NOT_FOUND" ? "Nothing found" : undefined;
        let t8;
        if ($[44] !== handleChange) {
          t8 = event_2 => handleChange(event_2.target.value || null, "immediate");
          $[44] = handleChange;
          $[45] = t8;
        } else {
          t8 = $[45];
        }
        let t10;
        let t9;
        if ($[46] !== onMenuOpenChange) {
          t9 = () => onMenuOpenChange?.(true);
          t10 = () => onMenuOpenChange?.(false);
          $[46] = onMenuOpenChange;
          $[47] = t10;
          $[48] = t9;
        } else {
          t10 = $[47];
          t9 = $[48];
        }
        let t11;
        if ($[49] !== field.id || $[50] !== onAnswerBlur) {
          t11 = () => onAnswerBlur?.(field.id);
          $[49] = field.id;
          $[50] = onAnswerBlur;
          $[51] = t11;
        } else {
          t11 = $[51];
        }
        let t12;
        if ($[52] !== autoFocus || $[53] !== field.label || $[54] !== readOnly || $[55] !== t10 || $[56] !== t11 || $[57] !== t2 || $[58] !== t4 || $[59] !== t5 || $[60] !== t6 || $[61] !== t7 || $[62] !== t8 || $[63] !== t9) {
          t12 = <Stack gap={0.5}><SelectInput id={t2} autoFocus={autoFocus} label={t3} hideLabel={true} disabled={readOnly} aria-labelledby={t4} value={t5} options={t6} placeholder={t7} onChange={t8} onOpen={t9} onClose={t10} onBlur={t11} /></Stack>;
          $[52] = autoFocus;
          $[53] = field.label;
          $[54] = readOnly;
          $[55] = t10;
          $[56] = t11;
          $[57] = t2;
          $[58] = t4;
          $[59] = t5;
          $[60] = t6;
          $[61] = t7;
          $[62] = t8;
          $[63] = t9;
          $[64] = t12;
        } else {
          t12 = $[64];
        }
        return t12;
      }
    case "multiSelect":
      {
        const t2 = `answer-${field.id}`;
        const t3 = field.label;
        const t4 = `answer-review-label-${field.id}`;
        let t5;
        if ($[65] !== field.currentRevision) {
          t5 = Array.isArray(field.currentRevision?.value) ? field.currentRevision.value : [];
          $[65] = field.currentRevision;
          $[66] = t5;
        } else {
          t5 = $[66];
        }
        let t6;
        if ($[67] !== field.editor.options) {
          t6 = field.editor.options.map(_temp2);
          $[67] = field.editor.options;
          $[68] = t6;
        } else {
          t6 = $[68];
        }
        let t7;
        if ($[69] !== handleChange) {
          t7 = event_1 => handleChange(event_1.target.value as string[], "immediate");
          $[69] = handleChange;
          $[70] = t7;
        } else {
          t7 = $[70];
        }
        let t8;
        let t9;
        if ($[71] !== onMenuOpenChange) {
          t8 = () => onMenuOpenChange?.(true);
          t9 = () => onMenuOpenChange?.(false);
          $[71] = onMenuOpenChange;
          $[72] = t8;
          $[73] = t9;
        } else {
          t8 = $[72];
          t9 = $[73];
        }
        let t10;
        if ($[74] !== field.id || $[75] !== onAnswerBlur) {
          t10 = () => onAnswerBlur?.(field.id);
          $[74] = field.id;
          $[75] = onAnswerBlur;
          $[76] = t10;
        } else {
          t10 = $[76];
        }
        let t11;
        if ($[77] !== autoFocus || $[78] !== field.label || $[79] !== readOnly || $[80] !== t10 || $[81] !== t2 || $[82] !== t4 || $[83] !== t5 || $[84] !== t6 || $[85] !== t7 || $[86] !== t8 || $[87] !== t9) {
          t11 = <Stack gap={0.5}><MultiSelectInput id={t2} autoFocus={autoFocus} label={t3} hideLabel={true} disabled={readOnly} aria-labelledby={t4} value={t5} options={t6} onChange={t7} onOpen={t8} onClose={t9} onBlur={t10} /></Stack>;
          $[77] = autoFocus;
          $[78] = field.label;
          $[79] = readOnly;
          $[80] = t10;
          $[81] = t2;
          $[82] = t4;
          $[83] = t5;
          $[84] = t6;
          $[85] = t7;
          $[86] = t8;
          $[87] = t9;
          $[88] = t11;
        } else {
          t11 = $[88];
        }
        return t11;
      }
    case "number":
      {
        const t2 = `answer-${field.id}`;
        const t3 = `answer-review-label-${field.id}`;
        const t4 = typeof field.currentRevision?.value === "number" ? field.currentRevision.value : "";
        let t5;
        if ($[89] !== field.label) {
          t5 = {
            "aria-label": field.label
          };
          $[89] = field.label;
          $[90] = t5;
        } else {
          t5 = $[90];
        }
        let t6;
        if ($[91] !== handleChange) {
          t6 = event_0 => {
            if (event_0.target.value === "") {
              handleChange(null, "debounced");
              return;
            }
            handleChange(Number(event_0.target.value), "debounced");
          };
          $[91] = handleChange;
          $[92] = t6;
        } else {
          t6 = $[92];
        }
        let t7;
        if ($[93] !== field.id || $[94] !== onAnswerBlur) {
          t7 = () => onAnswerBlur?.(field.id);
          $[93] = field.id;
          $[94] = onAnswerBlur;
          $[95] = t7;
        } else {
          t7 = $[95];
        }
        let t8;
        if ($[96] !== autoFocus || $[97] !== field.label || $[98] !== readOnly || $[99] !== t2 || $[100] !== t3 || $[101] !== t4 || $[102] !== t5 || $[103] !== t6 || $[104] !== t7) {
          t8 = <Stack gap={0.5}><TextInput id={t2} autoFocus={autoFocus} label={field.label} hideLabel={true} disabled={readOnly} aria-labelledby={t3} type="number" value={t4} inputProps={t5} onChange={t6} onBlur={t7} /></Stack>;
          $[96] = autoFocus;
          $[97] = field.label;
          $[98] = readOnly;
          $[99] = t2;
          $[100] = t3;
          $[101] = t4;
          $[102] = t5;
          $[103] = t6;
          $[104] = t7;
          $[105] = t8;
        } else {
          t8 = $[105];
        }
        return t8;
      }
    case "date":
      {
        const t2 = `answer-${field.id}`;
        const t3 = `answer-review-label-${field.id}`;
        const t4 = typeof field.currentRevision?.value === "string" ? field.currentRevision.value : "";
        let t5;
        if ($[106] !== field.label) {
          t5 = {
            "aria-label": field.label
          };
          $[106] = field.label;
          $[107] = t5;
        } else {
          t5 = $[107];
        }
        let t6;
        if ($[108] !== handleChange) {
          t6 = event => handleChange(event.target.value || null, "debounced");
          $[108] = handleChange;
          $[109] = t6;
        } else {
          t6 = $[109];
        }
        let t7;
        if ($[110] !== field.id || $[111] !== onAnswerBlur) {
          t7 = () => onAnswerBlur?.(field.id);
          $[110] = field.id;
          $[111] = onAnswerBlur;
          $[112] = t7;
        } else {
          t7 = $[112];
        }
        let t8;
        if ($[113] !== autoFocus || $[114] !== field.label || $[115] !== readOnly || $[116] !== t2 || $[117] !== t3 || $[118] !== t4 || $[119] !== t5 || $[120] !== t6 || $[121] !== t7) {
          t8 = <Stack gap={0.5}><TextInput id={t2} autoFocus={autoFocus} label={field.label} hideLabel={true} disabled={readOnly} aria-labelledby={t3} type="date" value={t4} inputProps={t5} onChange={t6} onBlur={t7} /></Stack>;
          $[113] = autoFocus;
          $[114] = field.label;
          $[115] = readOnly;
          $[116] = t2;
          $[117] = t3;
          $[118] = t4;
          $[119] = t5;
          $[120] = t6;
          $[121] = t7;
          $[122] = t8;
        } else {
          t8 = $[122];
        }
        return t8;
      }
    case "unsupported":
      {
        let t2;
        if ($[123] !== field.editor.message) {
          t2 = <Box role="note" px={1.5} py={1} borderRadius={1} bgcolor={COLORS.FUNCTIONAL.WARNING[50]}><Typography variant="body-xs">{field.editor.message}</Typography></Box>;
          $[123] = field.editor.message;
          $[124] = t2;
        } else {
          t2 = $[124];
        }
        return t2;
      }
    default:
      {
        throw new UnreachableError({
          case: field.editor,
          message: "Unknown answer editor"
        });
      }
  }
}
function _temp2(option) {
  return {
    value: option.value,
    display: option.label
  };
}
function _temp(option_0) {
  return {
    value: option_0.value,
    display: option_0.label
  };
}